module.exports = __webpack_public_path__ + "img/logo.5d9d28d0.png";